export const columns = {
  name: { flex: 1 },
  value: { width: 94, flex: '0 0 auto' },
};
